export default __webpack_public_path__ + "static/media/figuremap44.486ec515.png";